export const FEATURE = {
  RIVER: "0",
  WATERSHED: "1",
  ADMIN: "2",
  SHINSUISHIN_1: "3",
  SHINSUISHIN_2: "4",
};
